var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutline3Square(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.62 22.75c-2.3 0-3.37-1.07-3.37-3.37v-4.75c0-2.31 1.07-3.38 3.37-3.38H7c.41 0 .75.34.75.75v2.37c0 1.46.42 1.88 1.87 1.88H12c.41 0 .75.34.75.75v2.38c0 2.3-1.07 3.37-3.38 3.37H4.62zm-1.87-8.12v4.75c0 1.45.42 1.87 1.87 1.87h4.75c1.46 0 1.88-.42 1.88-1.87v-1.63H9.62c-2.3 0-3.37-1.07-3.37-3.38v-1.62H4.62c-1.45 0-1.87.42-1.87 1.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62 17.75c-2.3 0-3.37-1.07-3.37-3.38V9.62c0-2.3 1.07-3.37 3.37-3.37H12c.41 0 .75.34.75.75v2.37c0 1.46.42 1.88 1.87 1.88H17c.41 0 .75.34.75.75v2.37c0 2.31-1.07 3.38-3.38 3.38H9.62zM7.75 9.62v4.75c0 1.46.42 1.88 1.87 1.88h4.75c1.46 0 1.88-.42 1.88-1.88v-1.62h-1.63c-2.3 0-3.37-1.07-3.37-3.38V7.75H9.62c-1.45 0-1.87.42-1.87 1.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.62 12.75c-2.3 0-3.37-1.07-3.37-3.38V4.62c0-2.3 1.07-3.37 3.37-3.37h4.75c2.31 0 3.38 1.07 3.38 3.37v4.75c0 2.31-1.07 3.38-3.38 3.38h-4.75zm-1.87-8.13v4.75c0 1.46.42 1.88 1.87 1.88h4.75c1.46 0 1.88-.42 1.88-1.88V4.62c0-1.45-.42-1.87-1.88-1.87h-4.75c-1.45 0-1.87.42-1.87 1.87z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutline3Square);
export default __webpack_public_path__ + "static/media/vuesax-outline-3-square.33da0ca14c1c14c781642dc58c03b173.svg";
export { ForwardRef as ReactComponent };